import { auth } from "../firebase/firebaseConfig";

const endpoint = process.env.REACT_APP_API_ENDPOINT;

export class UserService {

    public static createUser = async ( fullname: string,  role: string) => {
        try {
            const token = await auth.currentUser?.getIdToken() || "";
            const response = await fetch(`${endpoint}/user/createUser`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': token
                },
                body: JSON.stringify({ fullname, role: role.toLowerCase(),fcmToken:"0" })    
            });
            if (!response.ok) {
                throw new Error(`Error ${response.status}: ${response.statusText}`);
            }

            const data = await response.json();
            return data;
        } catch (er: any) {
            throw new Error(er.message);
        }
    }

    public static getUser = async () => {
        try {
            const token = await auth.currentUser?.getIdToken() || "";
            const response = await fetch(`${endpoint}/user/getUser`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': token
                }
            });
            if (!response.ok) {
                throw new Error(`Error ${response.status}: ${response.statusText}`);
            }

            const data = await response.json();
            return data;
        } catch (er: any) {
            throw new Error(er.message);
        }
    }

    public static getmyLibrary = async () => {
        try {
            const token = await auth.currentUser?.getIdToken() || "";
            const response = await fetch(`${endpoint}/user/getMyLibraryWithoutAsync`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': token
                }
            });
            if (!response.ok) {
                throw new Error(`Error ${response.status}: ${response.statusText}`);
            }

            const data = await response.json();
            return data;
        } catch (er: any) {
            throw new Error(er.message);
        }
    }

    public static editUser = async (updates: { fullname?: string; role?: string }) => {
        try {
            const token = await auth.currentUser?.getIdToken() || "";
            const response = await fetch(`${endpoint}/user/edit`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': token
                },
                body: JSON.stringify(updates)
            });
            if (!response.ok) {
                throw new Error(`Error ${response.status}: ${response.statusText}`);
            }

            const data = await response.json();
            return data;
        } catch (er: any) {
            throw new Error(er.message);
        }
    }

    public static getUserOrders=async (
        page: number = 1,
        limit: number = 10,
        sortBy?: string,
        sortOrder?: 'asc' | 'desc',
        searchTerm?: string
    )=>{
        try {
            const token = await auth.currentUser?.getIdToken() || ""; 
            let url = `${endpoint}/order/getUserOrders?page=${page}&limit=${limit}`;
            if (sortBy) url += `&sortBy=${sortBy}`;
            if (sortOrder) url += `&sortOrder=${sortOrder}`;
            if (searchTerm) url += `&orderId=${searchTerm}`;
            const response = await fetch(url, {

                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': token
                } 
            });
            if (!response.ok) {
                throw new Error(`Error ${response.status}: ${response.statusText}`);
            }

            const data = await response.json();
            return data;
        } catch (er: any) {
            throw new Error(er.message);
        }
    }

    public static async accessBook(accessCode: string, bookId: string | undefined) {
        try {
            const token = await auth.currentUser?.getIdToken() || "";

            const response = await fetch(`${endpoint}/user/accessBook`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': token
                },
                body: JSON.stringify({
                    accessCode,
                    bookId
                })
            });

            const data = await response.json();
            return data;
        } catch (er: any) {
            throw new Error(er.message);
        }
    }

    public static setUUID = async (webUUID: string): Promise<any> => {
        try {
            const token = await auth.currentUser?.getIdToken() || "";
            const response = await fetch(`${endpoint}/user/setWebUUID`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: token
                },
                body: JSON.stringify({ webUUID })
            });

            if (!response.ok) {
                throw new Error(`Error ${response.status}: ${response.statusText}`);
            }

            const res = await response.json(); 
            return res;
        } catch (err: any) {
            return true;
        }
    };

    public static poll = async (webUUID: string): Promise<any> => {
        try {
            const token = await auth.currentUser?.getIdToken() || "";
            const response = await fetch(`${endpoint}/user/verifyWebUUID`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: token
                },
                body: JSON.stringify({ webUUID })
            });

            const res = await response.json();
            return res;
        } catch (err: any) {
            return true; // fallback to "do nothing" to avoid logging user out on errors
        }
    };

    public static checkEmailAvailability = async (email: string): Promise<any> => {
        try {
            const token = await auth.currentUser?.getIdToken() || "";
            const response = await fetch(`${endpoint}/user/check-email`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: token
                },
                body: JSON.stringify({ email })
            });

            const res = await response.json();
            return res;
        } catch (err: any) {
            return true; // fallback to "do nothing" to avoid logging user out on errors
        }
    };

}
